import React, { Component } from 'react';
import Slider from 'react-slick';
import DeskSliderContent from './DeskSliderContent.jsx';
import MobileSliderContent from './MobileSliderContent.jsx';

import dispatchEvent from '../../../fns/common/dispatchEvent';

import genesis from '../../../assets/images/genesis-slide.gif';
import fanepack from '../../../assets/images/fanepack-slide.gif';
import owners from '../../../assets/images/owners-slide.gif';

const Genesis = () => {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const mobileSliderSettings = {
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <section className="genesis-slider" id="collection-slide">
      <div className="px-5 md:px-10">
        <Slider className="desktop-slider" {...sliderSettings}>
          {/* Genesis Slide */}
          <DeskSliderContent
            id="genesis"
            leftHeader="Learn About Our Collections"
            centerHeader="The Genesis Collection"
            rightHeader="Genesis Metafans"
            leftText="Collect and trade the best sports-focused NFTs!"
            slideNumber="01"
            imgUrl={genesis}
            rightText="Each NFT is unique. Own a complete set, The Jock, The Cheerleader, The Die Hard, and the Average Joe, and get enhanced member benefits!"
            cta="Mint a MetaFan NFT"
            ctaOnClick={() => dispatchEvent('opensaleModalRequested')}
          ></DeskSliderContent>
          {/* FanEpack Slide */}
          <DeskSliderContent
            id="fanepack"
            leftHeader="Upgrade Your Metafans Collection"
            centerHeader="Get a Free FanEpack"
            rightHeader="Free With Each Metafans Genesis NFT"
            leftText="Every MetaFan's mint gets you a FREE FanEpack!"
            slideNumber="02"
            imgUrl={fanepack}
            rightText="Each NFT is unique. Own a complete set, The Jock, The Cheerleader, The Die Hard, and the Average Joe, and get enhanced member benefits!"
            cta="Mint a MetaFan NFT"
            ctaOnClick={() => dispatchEvent('opensaleModalRequested')}
          ></DeskSliderContent>
          {/* Owners Slide */}
          <DeskSliderContent
            id="owners"
            leftHeader="Exclusive Hand Drawn Art"
            centerHeader="Learn About Our Collections"
            rightHeader="Our Rare Sets"
            leftText="Collect the most unique and valuable MetaFans NFTs! Our Owners Box Guests are unique 1/1 MetaFans! Keep your fingers crossed when you mint a MetaFan, as you might acquire one of these and get some added benefits!"
            slideNumber="03"
            imgUrl={owners}
            rightText="Explore all of the MetaFans collections! Learn about the rarest and most valuable NFTs and the different traits available within each collection."
            cta="Learn More"
            ctaLink="/nft-utilities"
          ></DeskSliderContent>
        </Slider>
        <Slider className="mobile-slider py-10" {...mobileSliderSettings}>
          {/* Genesis Slide */}
          <MobileSliderContent
            id="genesis"
            header="The Genesis Collection"
            bodyText="Each NFT is unique. Own a complete set, The Jock, The Cheerleader, The Die Hard, and the Average Joe, and get enhanced member benefits!"
            slideNumber="01"
            imageUrl={genesis}
            ctaOnClick={() => dispatchEvent('opensaleModalRequested')}
            cta="Mint a MetaFan NFT"
          ></MobileSliderContent>
          {/* FanEpack Slide */}
          <MobileSliderContent
            id="fanepack"
            header="Get a Free FanEpack"
            bodyText="Win exclusive access to IRL experiences!"
            slideNumber="02"
            imageUrl={fanepack}
            ctaOnClick={() => dispatchEvent('opensaleModalRequested')}
            cta="Mint a MetaFan NFT"
          ></MobileSliderContent>
          {/* Owners Slide */}
          <MobileSliderContent
            id="owners"
            header="Learn About Our Collections"
            bodyText="Explore all of the MetaFans collections! Learn about the rarest and most valuable NFTs and the different traits available within each collection."
            slideNumber="03"
            imageUrl={owners}
            ctaLink="/nft-utilities"
            cta="Learn More"
          ></MobileSliderContent>
        </Slider>
      </div>
    </section>
  );
};

export default Genesis;
